<template>
    <v-dialog v-model="dialog" persistent width="300" @keydown.esc="close()">

        <v-card color="primary" dark>
            <v-card-text class="title layout justify-center">
                Attendere...
                <v-divider></v-divider>
                <v-progress-circular :size="40" color="white" indeterminate></v-progress-circular>
            </v-card-text>
        </v-card>

        <!-- <v-btn color="primary darken-1" text small outlined @click.native="cancel()">chiudi</v-btn> -->
    </v-dialog>
</template>



<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>